/* eslint-disable @typescript-eslint/ban-ts-ignore */
import * as Actions from './actions/actions';
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import offerReducer from './reducers/offerReducer';
import welcomeUserReducer from './reducers/welcomeUserReducer';
import seFlowReducer from './reducers/seFlowReducer';
//@ts-ignore
import * as postMessageUtilities from '@alme/ui-web/modules/lib-postmessage/lib/lib-postmessage';
import {AlightStateType}  from '../../types/alight-state';
import { Store } from 'redux';
import LaunchOffersAppEventUtility from '../launch-offers-appevent-utility/launchOffersAppEventUtility';
import {traceLog} from '../../src/logging';
/**
 * LaunchOffersProcessor is responsible for processing offers for a User on launch received from
 * received from the ClientCommunicator. It also removes the message after it is processed.
*/
export default class LaunchOffersProcessor
{
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | null = null;
    _launchOffersAppEventUtility: LaunchOffersAppEventUtility;
    _launchRetryCounter = 0;

    constructor(passedSettings: AlightCustomSettingsType, launchOffersAppEventUtility: LaunchOffersAppEventUtility)
    {
        this._settings = passedSettings;
        this._launchOffersAppEventUtility = launchOffersAppEventUtility;
    }

    getOfferReducer(): (state: {} | undefined, action: any) => {}
    {
        return offerReducer;
    }

    getWelcomeUserReducer(): (state: {} | undefined, action: any) => {}
    {
        return welcomeUserReducer;
    }

    getSEFlowReducer(): (state: {} | undefined, action: any) => {}
    {
        return seFlowReducer;
    }

    initialize(store: Store<AlightStateType>): void
    {
        this._store = store;

        postMessageUtilities.setupStateWatchForReceivedMessages(this._settings, this._store, this.processPostMessage.bind(this));
    }
    
    processPostMessage(newVal: any): void{
        if (this._store?.getState()?.WelcomeUser?.LaunchPointName === 'SimplifiedAE') {
            const { disableLaunchEvents } = this._settings.stateLocations.Window;
            this._store?.dispatch(Actions.setDisableLaunchEvents(true, disableLaunchEvents));
        }

        let msg = postMessageUtilities.getAndValidateMessage(newVal, 'hypeoffer');

        if(msg !== null){
            if (!this._store?.getState()?.Window?.IsEmbedded && !this._store?.getState()?.Window?.disableLaunchEvents) {
            this.processHypeMessage(msg);
            }
        }

        msg = postMessageUtilities.getAndValidateMessage(newVal, 'assistticket');

        if(msg !== null){
            if (!this._store?.getState()?.Window?.IsEmbedded && !this._store?.getState()?.Window?.disableLaunchEvents) {
            this.processTicketAssistMessage(msg);
            }
        }

        return;
    }

    processTicketAssistMessage(msg: any): void
    {
        if (msg == null || msg.message?.Data?.assistTicketData  == null )
        {
            return;
        }

        const offerData = msg.message?.Data?.assistTicketData || "";
        traceLog(`Assist ticket found. Processing offer data.`, 'LaunchOffersProcessor');
        this.processOfferData("AssistTicketUpdate", offerData);
        
    }

    processHypeMessage(msg: any): void
    {
        if (msg == null || msg.message?.Data?.hypeDetailsList  == null || msg.message?.Data?.hypeDetailsList?.length < 1  || !Array.isArray(msg.message?.Data?.hypeDetailsList) )
        {
            return;
        }

        const offerData = msg.message?.Data?.hypeDetailsList.slice(0, this._settings.maxHypeOffers) || "";

        for (let i = 0; i < offerData.length; i++) {
            const linkText = offerData[i]?.siteLink;
            const hypeOffer = offerData[i]?.associatedOffer;
            const queryIndex = linkText?.indexOf('?');
            const arr = queryIndex >= 0 ? [linkText.slice(0, queryIndex), linkText.slice(queryIndex + 1)] : [linkText, ""];
            const queryParams = new URLSearchParams(arr[1]);
            queryParams.set("hype_offer", hypeOffer);
            offerData[i].siteLink = `${arr[0]}?${queryParams.toString()}`;
          }
        
        this.processOfferData("HypeOffer", offerData);
    }

    processOfferData(offerName: string, offerData: string): void{
        if(this._store) {
            this._store.dispatch(Actions.markOfferAvailable(offerName));
            this._store.dispatch(Actions.saveOfferData(offerName, offerData));

            const state = this._store?.getState() || [];

            const offerProvided = state.Offers?.OffersProvided?.includes(offerName);

            if(this.isActiveSession() && !offerProvided){
                if(this.hasProcessedWelcomeUser() || this._launchRetryCounter >= 20){
                    this._launchRetryCounter = 0;
                    
                    this.debugMessage('Launching offer app event');
                    let elementt = document.getElementsByClassName(`${this._settings.classNames.launchPoint}`);
                    if (elementt.length > 0) {
                        elementt[0].className = `${this._settings.classNames.launchPoint} ${this._settings.classNames.launchPointHype}`;
                    }
                    this._launchOffersAppEventUtility.sendLaunchOfferAppEvent(offerName);
                }
                else{
                    setTimeout(() =>{
                        this._launchRetryCounter = this._launchRetryCounter + 1;
                        this.debugMessage(`Attempt Number: ${this._launchRetryCounter} Active Session Found, but Welcome User not Processed. Reprocessing`);
                        this.processOfferData(offerName, offerData);
                    }, 500); 
                }
            }
            else{
                this.debugMessage('No active session found. Setting launch offer parameter');
                this._store.dispatch(Actions.setLaunchOffersParameter(offerName));
            }
        }
    }

    getMutator(){
        return (parameters = {}): {} => {
            const state = this._store?.getState();

            const hypeAvailable = state?.Offers?.OffersAvailable?.includes("HypeOffer");

            const hypeProvided = state?.Offers?.OffersProvided?.includes("HypeOffer");

            if(hypeAvailable && !hypeProvided && !this.isActiveSession()){
                return { ...parameters, className: `${this._settings.classNames.launchPoint} ${this._settings.classNames.launchPointHype}` };                
            }

            return parameters;
        };
    }

    isActiveSession(): boolean 
    {
        const state = this._store?.getState();

        //can suppress the welcome user appevent if needed
        const forceIsActiveSession = state?.WelcomeUser?.forceIsActiveSession || false;

        this.debugMessage(`Forcing active session: ${forceIsActiveSession}`);
        
        const activeSession = state?.Conversation?.IsActiveSession || false;
        return forceIsActiveSession || activeSession;
    }

    hasProcessedWelcomeUser(): boolean{
        const state = this._store?.getState();

        const history = state?.History?.HistoryMessages || [];

        this.debugMessage(`Checking chat history... ${history.length} messages found.`);

        return history.length > 0;
    }

    debugMessage(message: string): void{
        if (process.env.NODE_ENV !== 'production'){
            traceLog(message, 'LaunchOffersProcessor');
        }
    }
}



// WEBPACK FOOTER //
// ./modules/launch-offers-post-message-handling/LaunchOffersProcessor.ts